import * as constants from "./constants";

export const fetchLoginOptions = () => ({
  type: constants.FETCH_LOGIN_OPTIONS,
});

export const fetchLoginOptionsSuccess = (data) => ({
  type: constants.FETCH_LOGIN_OPTIONS_SUCCESS,
  payload: data,
});

export const fetchLoginOptionsError = () => ({
  type: constants.FETCH_LOGIN_OPTIONS_ERROR,
});

export const createLoginOptions = (data) => {
  return {
    type: constants.CREATE_LOGIN_OPTIONS,
    data,
  };
};

export const createLoginOptionsSuccess = (payload) => {
  return {
    type: constants.CREATE_LOGIN_OPTIONS_SUCCESS,
    payload,
  };
};

export const createLoginOptionsError = () => {
  return {
    type: constants.CREATE_LOGIN_OPTIONS_ERROR,
  };
};
